import { useEffect, useCallback, useState } from "react";
import * as signalR from "@microsoft/signalr";
import { useDispatch, useSelector } from "react-redux";
import configs from "../../configs/config";

const TicketUrl =configs.TICKET_HUB_URL;
export function useTicketRefreshService() {
  const dispatch = useDispatch();
  const currAgent = useSelector(
    (state: any) => state?.agentReducer?.loggedInAgent
  );
  const [myCurrAgent, setMyCurrAgent] = useState<any>(currAgent);

  // Keep myCurrAgent in sync with Redux state
  useEffect(() => {
    setMyCurrAgent(currAgent);
  }, [currAgent]);

  // Memoized handler with up-to-date dependencies
  const handleNewTicketRemove = useCallback(
    (data: any) => {
      const tenantCode = localStorage.getItem("tenantCode");
      if (
        tenantCode &&
        data?.tenantCode === tenantCode &&
        myCurrAgent?.id === data?.data?.ownerId
      ) {
        dispatch({ type: "DROPPED_TO_NEWTOME", payload: data?.ticketId });
      } else {
        dispatch({ type: "REMOVED_NEWTICKET", payload: data?.ticketId });
      }
    },
    [dispatch, myCurrAgent]
  );

  useEffect(() => {
    console.log("Initializing SignalR...");

    const connection = new signalR.HubConnectionBuilder()
      .withUrl(`${TicketUrl}/tickethub`, {
        transport:
          signalR.HttpTransportType.WebSockets |
          signalR.HttpTransportType.LongPolling,
      })
      .withAutomaticReconnect()
      .build();

    // Register handlers before starting the connection [6]
    connection.on("NewTicketRemoved", handleNewTicketRemove);

    connection
      .start()
      .then(() => {
        console.log("SignalR connected");
      })
      .catch((err) => {
        console.error("SignalR connection error:", err);
      });

    connection.onclose((error) => {
      console.warn("SignalR connection closed", error);
    });

    return () => {
      console.log("Cleaning up SignalR connection");
      connection.off("NewTicketRemoved", handleNewTicketRemove);
      connection.stop();
    };
  }, [handleNewTicketRemove]);

  // No return value needed for this hook
}
